"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewCustomDomainAlert = void 0;
var newCustomDomainAlert_1 = require("./newCustomDomainAlert");
Object.defineProperty(exports, "NewCustomDomainAlert", { enumerable: true, get: function () { return __importDefault(newCustomDomainAlert_1).default; } });
